import { render, staticRenderFns } from "./NavSidebar.vue?vue&type=template&id=643f7fb2&scoped=true"
import script from "./NavSidebar.vue?vue&type=script&lang=ts"
export * from "./NavSidebar.vue?vue&type=script&lang=ts"
import style0 from "./NavSidebar.vue?vue&type=style&index=0&id=643f7fb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643f7fb2",
  null
  
)

export default component.exports